import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { arrayIsDefinedAndContainsKey } from '../shared/array-functions';
import { CONSTANTS } from '../shared/constants';

@Injectable()
export class AtabexDataService {
  private apiUrl: string;
  public states: object[];

  constructor(private http: HttpClient) {
    this.apiUrl = environment.api.protocol + environment.api.hostname + environment.api.path;
  }

  /*
   * Get list of state IDs
   * API endpoint: StatesDescription
   */
  getStates() {
    const route = 'StatesDescription';
    return this.http.get(this.apiUrl + route).subscribe(
      (data) => {
        if (arrayIsDefinedAndContainsKey(data, 'CMS_SAM_Get_States')) {
          this.states = data['CMS_SAM_Get_States'];
        }
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
      });
  }

  /*
   * Check if two encrypted values are the same
   * API endpoint: ValidateEncryptedValues
   */
  validateEncryptedValues(value1, value2) {
    const route = 'ValidateEncryptedValues';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.value1QueryParam + '=' + value1 + '&' + CONSTANTS.api.value2QueryParam + '=' + value2)
      .map((res: Response) => {
        return res['Value'];
      }).catch((error: any) =>
        Observable.throw(error || 'Server error')
      );
  }

  private handleError(err: HttpErrorResponse) {
    if (err.error instanceof Error) {
      // A client-side or network error occurred
      console.log('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code
      console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/atabex-data.service.ts